// src/context/MenuProviderContext.js
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

import {
  API_BASE_URL,
  SERVER_BASE_URL,
  salvarDados,
  buscarDados,
  buscarDadosPorId,
  excluirDados,
  excluirDadosCompleto,
  excluirDadosPorId,
  excluirBanco,
} from '../services/indexedDb.js';
import UseCrud from '../hooks/useCrud';
import Toast from '../components/Alertas/Toast';
import Tour from '../pages/Tour';
import { Spinner } from 'react-bootstrap'; // Ou qualquer spinner de sua lib
import { navigateTo } from '../navigate';
import DeviceInfo, { getDeviceInfo } from '../components/Widgets/DeviceInfo'
import ShareWhatApp, { getDDDFromNumber, normalizeNumber, enviarWhatsApp, compartilharCaptura, baixarCaptura } from '../components/Utils/ShareWhatApp'

const MenuProviderContext = createContext();
export const useProvider = () => useContext(MenuProviderContext);
const isNative = !!(typeof window !== 'undefined' && window.Capacitor && window.Capacitor.isNativePlatform());


export const MenuProvider = ({ children }) => {
  const [selectedItem, setSelectedItem] = useState('');
  const [btns, setBtns] = useState([]);
  const [links, setLinks] = useState([]);
  const [title, setTitle] = useState();
  const [tour, setTour] = useState();
  
  const [lista, setLista] = useState([]);
  const [site, setSite] = useState();
  const [loja, setLoja] = useState();
  const [auth, setAuth] = useState();
  const [atalhos, setAtalhos] = useState();
  const [home, setHome] = useState();
  const [catalogo, setCatalogo] = useState('/c/');
  
  const [userAdmin, setUserAdmin] = useState();
  const [userCliente, setUserCliente] = useState();
  const [tokenAdmin, setTokenAdmin] = useState();
  const [tokenCliente, setTokenCliente] = useState();

  const crud = UseCrud();
  const crudAdmin = UseCrud({token : tokenAdmin});
  const crudCliente = UseCrud({token : tokenCliente});
  
  // Verifica permissões
  const hasPerms = (itens) => {
    const arr = Array.isArray(itens) ? itens : [itens];
    const listaSegura = Array.isArray(lista) ? lista : [];
    return arr.some((i) => listaSegura.includes(i));
  };
  const hasPermsAnd = (itens) => {
    const arr = Array.isArray(itens) ? itens : [itens];
    const listaSegura = Array.isArray(lista) ? lista : [];
    return arr.every((i) => listaSegura.includes(i));
  };

  const handleSelect = (eventKey) => {
    setSelectedItem(eventKey);
  };
  
  useEffect(()=>{
    return () => {
      setTitle(site?.name || ``);
    };
  }, [setTitle, site])
  
  const handleEvent = useCallback(async (event) => {
    const data = event.data;
    if (!data) return;
    //alert(data)
  
    console.log("Evento recebido:", data);
  
    if (data === "atualizar-atalhos") {
      const result = await buscarDadosPorId('local_registros', "atalhos");
      if (result) setAtalhos(result);
    }
  
    if (data === "atualizar-auth") {
      const app = await buscarDadosPorId("local_registros", "app");
      if (app) {
        setSite(app);
        setTitle(app?.name);
      }
      
      const appLoj = await buscarDadosPorId('local_registros', "loja");
      if (appLoj) setLoja(appLoj);
      
      const authData = await buscarDadosPorId("local_registros", "auth");
      setAuth(authData);
      setLista(authData?.permissions || []);
    }
  
    if (data === "login") {
      const authData = await buscarDadosPorId("local_registros", "auth");
      setAuth(authData);
      setLista(authData?.permissions || []);
      
      if (authData) {
        if (parseInt(authData?.permissions?.length || 0) === 0) {
          navigateTo('/config/');
        } else {
          navigateTo('/painel/');
        }
      } else {
        navigateTo('/login/');
      }
    }
  }, [setAtalhos, setAuth, setLista, setLoja, setSite, setTitle]);
  
  useEffect(() => {
    const isSW = 'serviceWorker' in navigator;
  
    if (isNative) {
      window.addEventListener("message", handleEvent);
    } else if (isSW) {
      navigator.serviceWorker.addEventListener("message", handleEvent);
    }
  
    return () => {
      window.removeEventListener("message", handleEvent);
      if (isSW) {
        navigator.serviceWorker.removeEventListener("message", handleEvent);
      }
    };
  }, [handleEvent]);

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    let cancelado = false;

    const carregarPrincipal = async () => {
      if (site || cancelado) return;
      try {
        const app = await buscarDadosPorId('local_registros', "app");
        if (app && !cancelado) {
          setSite(app);
          const user = await buscarDadosPorId('local_registros', "auth");
          setAuth(user);
          setLista(user?.permissions || []);
          
          const appLoj = app?.empresa || user?.empresa || (await buscarDadosPorId('local_registros', "loja"));
          setLoja(appLoj);
          
          let rotaInicial = "/painel/";
          if (!!app?.empresa?.url && !user) rotaInicial = `/c/`;
          else if (!!appLoj?.url && !user) rotaInicial = `/c/${appLoj?.url}/`;
          
          setHome(rotaInicial);
          if (!app?.empresa?.url) setCatalogo(`/c/${appLoj?.url?`${appLoj?.url}/`:''}`);
        } else if (!cancelado) {
          setTimeout(carregarPrincipal, 500);
        }
      } catch (err) {
        if (!cancelado) setTimeout(carregarPrincipal, 500);
      }
    };
    
    const carregarAuth = async () => {
      if (auth || cancelado) return;
      try{
        const user = await buscarDadosPorId('local_registros', "auth");
        if (user && !cancelado) {
          setAuth(user);
          setLista(user?.permissions || []);
        } else if (!cancelado) {
          setTimeout(carregarAuth, 500);
        }
      }catch{
        if (!cancelado) setTimeout(carregarAuth, 500);
      }
    };
    
    const carregarAtalhos = async () => {
      if (atalhos || cancelado) return;
      try{
        const result = await buscarDadosPorId('local_registros', "atalhos");
        if (result && !cancelado) {
          setAtalhos(result);
        } else if (!cancelado) {
          setTimeout(carregarAtalhos, 500);
        }
      }catch{
        if (!cancelado) setTimeout(carregarAtalhos, 500);
      }
    };
    
    carregarPrincipal();
    carregarAuth();
    carregarAtalhos();

    return () => {
      cancelado = true;
    };
  }, [site, loja, auth, atalhos]);
  
  const handleBaixar = async (divRef, dados) => {
    return await baixarCaptura(divRef, dados, Toast, isNative, site?.name);
  };
  
  const handleNormalizarTelefone = (telefone) => {
    const ddd = getDDDFromNumber(auth?.empresa?.telefone_whatsapp) || null;
    return normalizeNumber(telefone, ddd);
  };
  
  const handleFormatarTelefone = (telefone) => {
    const telefoneLimpo = handleNormalizarTelefone(telefone);
    if (!telefoneLimpo || telefoneLimpo.length < 11) return '';
  
    const ultimos11 = telefoneLimpo.slice(-11);
  
    const ddd = ultimos11.slice(0, 2);
    const parte1 = ultimos11.slice(2, 7);
    const parte2 = ultimos11.slice(7, 11);
  
    return `(${ddd}) ${parte1}-${parte2}`;
  };
  
  const handleCompartilhar = async (divRef, dados) => {
    return await compartilharCaptura(divRef, dados, Toast, isNative, site?.name);
  };

  const handleEnviarWhats = async (telefone, mensagem) => {
    return await enviarWhatsApp(telefone, mensagem, Toast, isNative);
  };

  if (!site) {
    return <p className="text-center"><Spinner animation="border" /></p>;
  }

  return (
    <MenuProviderContext.Provider
      value={{
        selectedItem,
        handleSelect,
        btns,
        setBtns,
        links,
        setLinks,
        site,
        home,
        catalogo,
        loja,
        setLoja,
        auth,
        setAuth,
        userAdmin,
        setUserAdmin,
        userCliente,
        setTokenCliente,
        tokenCliente,
        setTokenAdmin,
        tokenAdmin,
        crud,
        crudAdmin,
        crudCliente,
        lista,
        atalhos,
        hasPerms,
        hasPermsAnd,
        API_BASE_URL,
        SERVER_BASE_URL,
        salvarDados,
        buscarDados,
        excluirDadosCompleto,
        buscarDadosPorId,
        excluirDados,
        excluirDadosPorId,
        excluirBanco,
        getDeviceInfo,
        navigateTo,
        title,
        setTitle,
        setTour,
        handleBaixar,
        handleEnviarWhats,
        handleCompartilhar,
        handleNormalizarTelefone,
        handleFormatarTelefone,
      }}
    >
      {children}
      <Tour id={tour?.id} lista={tour?.lista} />
    </MenuProviderContext.Provider>
  );
};

export {
  Toast,
  Spinner,
  DeviceInfo,
  isNative,
  ShareWhatApp,
}
